import React from 'react';
import { TranslationView } from '@levelapp/softfabric-ui';
import {Image, Text, View} from 'react-native';
import PreviousProject from '../../../../../Common/DTO/PreviousProject';
import { styles } from "./PreviousProjectsViewStyle";
import {useWindowSizeContext} from "../../../../../Common/contexts/WindowSizeContext";
import {Application, LanguageManager, Managers} from "@levelapp/softfabric";
import Translation from "../../../../../Common/DTO/Translation";

type TranslationKeys = "fr" | "nl" | "en";

interface PreviousProjectsViewProps {
    previousProjects: PreviousProject[];
}

export const PreviousProjectsView = ({previousProjects}: PreviousProjectsViewProps) => {

    const {width, isMobile} = useWindowSizeContext();

    const languageManager: LanguageManager = Application.current.resolve<LanguageManager>(Managers.LANGUAGE_MANAGER);
    const languageKey: TranslationKeys = languageManager.language.split('-')[0] as TranslationKeys;

    if (previousProjects.length === 0) return null;

    return (
        <View style={styles.page}>
            {previousProjects[0].name && previousProjects[0].name !== "Projet" && previousProjects[0].name.length !== 0 ? (
                <Text style={styles.title}>{previousProjects[0].name}</Text>
            ) : (
                <TranslationView style={styles.title}>leader.previousProjects</TranslationView>
            )}
            <View style={isMobile ? styles.colContainer : styles.rowContainer}>
                {isMobile ? (
                    <>
                        {previousProjects.map((preProj: PreviousProject, index: number) => {
                            return (
                                <View
                                    key={index}
                                    style={styles.rowBox}
                                >
                                    <Image style={[styles.image, {width: width*0.5, height: width*0.5}]} source={{ uri: preProj.pictureUrl }} />
                                    <View style={{height: 20}}/>
                                    <PreviousProjectDescription preProj={preProj} languageKey={languageKey}/>
                                </View>
                            )
                        })}
                    </>
                ) : (
                    <>
                        {previousProjects.map((preProj: PreviousProject, index: number) => {
                            return (
                                <View
                                    key={index}
                                    style={styles.colBox}
                                >
                                    <Image style={[styles.image, {width: width * 0.15, height: width * 0.15}]}
                                           source={{uri: preProj.pictureUrl}}/>
                                    <View style={{height: 20}}/>
                                    <PreviousProjectDescription preProj={preProj} languageKey={languageKey}/>
                                </View>
                            )
                        })}
                    </>
                )}

            </View>
        </View>
    );
}

type PreviousProjectDescriptionProps = {
    preProj: PreviousProject;
    languageKey: keyof Translation;
}

function PreviousProjectDescription({preProj, languageKey}: PreviousProjectDescriptionProps) {
    return (
        <View style={{width: '90%', justifyContent: 'center'}}>
            {(preProj.description.fr && preProj.description.nl && preProj.description.en) ? (
                <View style={{flexDirection: 'column'}}>
                    {(preProj.name !== "Projet" && preProj.name.length !== 0) && (
                        <Text style={styles.previousProjectTitle}>{preProj.name}</Text>
                    )}
                    <Text style={styles.previousProjectTitle}>{preProj.localisation[languageKey]}</Text>
                    <Text style={styles.previousProjectDescription}>{preProj.description[languageKey]}</Text>
                </View>
            ) : (
                <BulletsInformations
                    buildingText={(preProj.buildingText?.[languageKey] as string) ?? ""}
                    financeText={(preProj.financeText?.[languageKey] as string) ?? ""}
                    locationText={(preProj.locationText?.[languageKey] as string) ?? ""}
                    surfaceText={(preProj.surfaceText?.[languageKey] as string) ?? ""}
                    realisationDateText={(preProj.realisationDateText?.[languageKey] as string) ?? ""}
                />
            )}
        </View>
    );
}

type BulletsInformationsProps = {
    buildingText: string;
    financeText: string;
    locationText: string;
    surfaceText: string;
    realisationDateText: string;
}

function BulletsInformations({buildingText, financeText, locationText, surfaceText, realisationDateText}: BulletsInformationsProps) {
    return (
        <>
            {buildingText && (
                <View style={[styles.bulletContainer]}>
                    <Image style={[styles.bulletImage]} source={require('./assets/house.png')}/>
                    <Text style={[styles.bulletText]}>{buildingText}</Text>
                </View>
            )}
            {financeText && (
                <View style={[styles.bulletContainer]}>
                    <Image style={[styles.bulletImage]} source={require('./assets/finance.png')}/>
                    <Text style={[styles.bulletText]}>{financeText}</Text>
                </View>
            )}
            {locationText && (
                <View style={[styles.bulletContainer]}>
                    <Image style={[styles.bulletImage]} source={require('./assets/location.png')}/>
                    <Text style={[styles.bulletText]}>{locationText}</Text>
                </View>
            )}
            {surfaceText && (
                <View style={[styles.bulletContainer]}>
                    <Image style={[styles.bulletImage]} source={require('./assets/surface.png')}/>
                    <Text style={[styles.bulletText]}>{surfaceText}</Text>
                </View>
            )}
            {realisationDateText && (
                <View style={[styles.bulletContainer]}>
                    <Image style={[styles.bulletImage]} source={require('./assets/timeline.png')}/>
                    <Text style={[styles.bulletText]}>{realisationDateText}</Text>
                </View>
            )}
        </>
    )
}

export default PreviousProjectsView;